/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { EvidencePaymentWithEvidenceErrors } from './evidence-payment-with-evidence-errors';
// May contain unused imports in some cases
// @ts-ignore
import { EvidencePaymentWithEvidenceInvoiceIssuer } from './evidence-payment-with-evidence-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { EvidencePaymentWithEvidenceUpdatedBy } from './evidence-payment-with-evidence-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { EvidencePaymentWithEvidenceUploadedBy } from './evidence-payment-with-evidence-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { EvidencePaymentWithEvidenceWarnings } from './evidence-payment-with-evidence-warnings';

/**
 * 
 * @export
 * @interface EvidencePaymentWithEvidence
 */
export interface EvidencePaymentWithEvidence {
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'paymentType': EvidencePaymentWithEvidencePaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'paidAt': string;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'issuer': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'electronicMethod': EvidencePaymentWithEvidenceElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'documentSize': EvidencePaymentWithEvidenceDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'legalValidity': EvidencePaymentWithEvidenceLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidencePaymentWithEvidence
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {EvidencePaymentWithEvidenceInvoiceIssuer}
     * @memberof EvidencePaymentWithEvidence
     */
    'invoiceIssuer': EvidencePaymentWithEvidenceInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     * @deprecated
     */
    'dpiError': EvidencePaymentWithEvidenceDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     * @deprecated
     */
    'detectedDpiError': EvidencePaymentWithEvidenceDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     * @deprecated
     */
    'calculatedDpiError': EvidencePaymentWithEvidenceCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     * @deprecated
     */
    'colorGradationError': EvidencePaymentWithEvidenceColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     * @deprecated
     */
    'heightMillisError': EvidencePaymentWithEvidenceHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     * @deprecated
     */
    'widthMillisError': EvidencePaymentWithEvidenceWidthMillisErrorEnum;
    /**
     * 
     * @type {EvidencePaymentWithEvidenceErrors}
     * @memberof EvidencePaymentWithEvidence
     */
    'errors': EvidencePaymentWithEvidenceErrors;
    /**
     * 
     * @type {EvidencePaymentWithEvidenceWarnings}
     * @memberof EvidencePaymentWithEvidence
     */
    'warnings': EvidencePaymentWithEvidenceWarnings;
    /**
     * 
     * @type {EvidencePaymentWithEvidenceUpdatedBy}
     * @memberof EvidencePaymentWithEvidence
     */
    'updatedBy': EvidencePaymentWithEvidenceUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'updatedAt': string;
    /**
     * 
     * @type {EvidencePaymentWithEvidenceUploadedBy}
     * @memberof EvidencePaymentWithEvidence
     */
    'uploadedBy': EvidencePaymentWithEvidenceUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidencePaymentWithEvidence
     */
    'deleted': boolean;
}

export const EvidencePaymentWithEvidencePaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type EvidencePaymentWithEvidencePaymentTypeEnum = typeof EvidencePaymentWithEvidencePaymentTypeEnum[keyof typeof EvidencePaymentWithEvidencePaymentTypeEnum];
export const EvidencePaymentWithEvidenceElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceElectronicMethodEnum = typeof EvidencePaymentWithEvidenceElectronicMethodEnum[keyof typeof EvidencePaymentWithEvidenceElectronicMethodEnum];
export const EvidencePaymentWithEvidenceDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceDocumentSizeEnum = typeof EvidencePaymentWithEvidenceDocumentSizeEnum[keyof typeof EvidencePaymentWithEvidenceDocumentSizeEnum];
export const EvidencePaymentWithEvidenceLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type EvidencePaymentWithEvidenceLegalValidityEnum = typeof EvidencePaymentWithEvidenceLegalValidityEnum[keyof typeof EvidencePaymentWithEvidenceLegalValidityEnum];
export const EvidencePaymentWithEvidenceDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceDpiErrorEnum = typeof EvidencePaymentWithEvidenceDpiErrorEnum[keyof typeof EvidencePaymentWithEvidenceDpiErrorEnum];
export const EvidencePaymentWithEvidenceDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceDetectedDpiErrorEnum = typeof EvidencePaymentWithEvidenceDetectedDpiErrorEnum[keyof typeof EvidencePaymentWithEvidenceDetectedDpiErrorEnum];
export const EvidencePaymentWithEvidenceCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceCalculatedDpiErrorEnum = typeof EvidencePaymentWithEvidenceCalculatedDpiErrorEnum[keyof typeof EvidencePaymentWithEvidenceCalculatedDpiErrorEnum];
export const EvidencePaymentWithEvidenceColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidencePaymentWithEvidenceColorGradationErrorEnum = typeof EvidencePaymentWithEvidenceColorGradationErrorEnum[keyof typeof EvidencePaymentWithEvidenceColorGradationErrorEnum];
export const EvidencePaymentWithEvidenceHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type EvidencePaymentWithEvidenceHeightMillisErrorEnum = typeof EvidencePaymentWithEvidenceHeightMillisErrorEnum[keyof typeof EvidencePaymentWithEvidenceHeightMillisErrorEnum];
export const EvidencePaymentWithEvidenceWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type EvidencePaymentWithEvidenceWidthMillisErrorEnum = typeof EvidencePaymentWithEvidenceWidthMillisErrorEnum[keyof typeof EvidencePaymentWithEvidenceWidthMillisErrorEnum];


